"use client";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { TransitionGroup } from "react-transition-group";
import { Box } from "@mui/material";
import { Animation as DefaultAnimation, CLEAN_UP_NOTIFICATION_CUSTOM_EVENT_NAME, } from "./components/Animation";
import { removeNotification, listenToCustomEvent, NOTIFICATION_CUSTOM_EVENT_NAME, REMOVE_NOTIFICATION_CUSTOM_EVENT_NAME, } from "./functions";
const sxStyles = ({ zIndex }) => ({
    root: {
        zIndex: zIndex.appBar,
        position: "fixed",
        width: "100%",
    },
});
export const NotificationBar = ({ className, Animation = DefaultAnimation }) => {
    const [notifications, setNotifications] = useState([]);
    useLayoutEffect(() => {
        return listenToCustomEvent(NOTIFICATION_CUSTOM_EVENT_NAME, (evt) => {
            const detail = evt.detail;
            const extendedDetail = { timestamp: Date.now(), ...detail, status: "SHOW" };
            setNotifications([...notifications, extendedDetail]);
            if (extendedDetail.durationInMS !== "STICKY") {
                setTimeout(() => {
                    removeNotification(extendedDetail.id);
                }, extendedDetail.durationInMS);
            }
        });
    }, [notifications]);
    useEffect(() => {
        return listenToCustomEvent(REMOVE_NOTIFICATION_CUSTOM_EVENT_NAME, (evt) => {
            const detail = evt.detail;
            const removeNotificationId = detail.id;
            const updatedNotifications = notifications.map((n) => {
                if (n.id === removeNotificationId) {
                    return { ...n, status: "REMOVE" };
                }
                return n;
            });
            setNotifications(updatedNotifications);
        });
    }, [notifications]);
    useEffect(() => {
        return listenToCustomEvent(CLEAN_UP_NOTIFICATION_CUSTOM_EVENT_NAME, (evt) => {
            const detail = evt.detail;
            const cleanUpNotificationId = detail.id;
            const updatedNotifications = notifications.filter((n) => n.id !== cleanUpNotificationId);
            setNotifications(updatedNotifications);
        });
    }, [notifications]);
    return (React.createElement(Box, { component: TransitionGroup, className: className, sx: (theme) => sxStyles(theme).root }, notifications.map((n) => (React.createElement(Animation, { key: `notification-${n.id}`, notificationId: n.id, status: n.status }, n.content)))));
};
//# sourceMappingURL=NotificationBar.js.map